"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fmko_ts_common_1 = require("fmko-ts-common");
/**
 * @deprecated use document.createElement("h1|h2|h3|h4|h5|h6") instead, element loses its type when using this class
 */
class HeadingLabel extends fmko_ts_common_1.Widget {
    constructor(level, text) {
        super();
        this.level = level;
        this.element = document.createElement(`h${level}`);
        this.setText(text);
    }
    setText(text) {
        if (text) {
            this.element.innerText = text;
        }
    }
    getText() {
        return this.element.innerText;
    }
}
exports.default = HeadingLabel;
//# sourceMappingURL=HeadingLabel.js.map